import { FormGroup } from '@angular/forms';
import { distinctUntilChanged, startWith } from 'rxjs';

export const listenFormValue$ = (form: FormGroup) =>
  form.valueChanges.pipe(startWith(form.value), distinctUntilChanged());
